// extracted by css-extract-rspack-plugin
export default {"cls1":"FeedbackForm-cls1_HWt","cls2":"FeedbackForm-cls2_dBl FeedbackForm-cls1_HWt"};